import { useSyncExternalStore } from 'react'

/** Whether a media query matches, as a value a component can branch on. For the layouts CSS
 *  cannot express — two different trees, not one reordered — where rendering both and hiding
 *  one costs a second React tree, a second query observer and a permanently fragile test. */
export function useMediaQuery(query: string, whenUnknown = false): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query)
      list.addEventListener('change', onChange)
      return () => {
        list.removeEventListener('change', onChange)
      }
    },
    () => window.matchMedia(query).matches,
    () => whenUnknown,
  )
}

/** Whoever asked the system for less motion: what moves is told so in JS, and stands still. */
export const REDUCED_MOTION = '(prefers-reduced-motion: reduce)'

/** Tailwind's own breakpoints, so a component that branches in JS and a class that branches
 *  in CSS cannot drift apart. */
export const SCREEN_SM = '(min-width: 40rem)'
export const SCREEN_LG = '(min-width: 64rem)'
